import { registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';
import { createAlphanumericFormatter } from '@philips-emr/tws-model/lib/generators/';

import employerIdentificationNumberValidator from '../validators/employer-identification-number-validator';

export const EMPLOYER_IDENTIFICATION = 'employee-identification-number';

const EmployerIdentificationNumberFormatter = createAlphanumericFormatter({
  name: EMPLOYER_IDENTIFICATION,
  mask: '00.000.000/0000-00',
  validate: employerIdentificationNumberValidator,
  invalidMessage: 'pa.invalid-ein',
});

export default registerFormatter('employer-identification-number', EmployerIdentificationNumberFormatter);
